'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT = undefined;

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

exports.match = match;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT = exports.DEFAULT = (0, _symbol2.default)('Default');

function match(matchOn, cases) {
  var val = matchOn in cases ? cases[matchOn] : DEFAULT in cases ? cases[DEFAULT] : noMatch(matchOn);

  return typeof val === 'function' ? val() : val;
}

function noMatch(matchOn) {
  throw new Error('No match for ' + matchOn);
}

match.DEFAULT = DEFAULT;
//# sourceMappingURL=patternMatchUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/patternMatchUtil.js
// module id = 101
// module chunks = 0